export default function getResource(label, vars = []) {
    const resources = {
        basket: 'panier',
        checkout: 'Passer à la caisse',
        item: 'article',
        total: `Vous avez ${vars[0]} dans votre ${vars[1]}.`,
        applyPoints: 'Échangez *500 points * pour* profiter d’une réduction de 10 $%%*  à la caisse',
        freeShipping: 'Expédition standard GRATUITE',
        offerDetailsTitle: 'Détails de l’offre',
        readMore: 'En lire plus',
        readLess: 'En lire moins',
        apply: 'Appliquer',
        applying: 'Application en cours…',
        applied: 'Appliqué',
        remove: 'Supprimer',
        removing: 'Suppression en cours…',
        applyError: 'Impossible d’appliquer la promotion. Veuillez essayer de nouveau.',
        removeError: 'Impossible de supprimer la promotion. Veuillez essayer de nouveau.'
    };

    return resources[label];
}
